<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{name: item.name, icon: item.icon, path: item.path}"
          v-bind:key="item.name"
          v-for="item in menu"
        >
          <sidebar-item
            v-for="subItem in item.children"
            :link="{name: subItem.name, icon: subItem.icon, path: subItem.path}"
            v-bind:key="subItem.name"
          ></sidebar-item>
        </sidebar-item>

        <!-- <sidebar-item :link="{name: 'Summary', icon: 'now-ui-icons design_image'}">
          <sidebar-item :link="{name: 'Order List', path: '/summary/orders'}"></sidebar-item>
        </sidebar-item>-->
      </template>
      <!-- <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{name: '營業統計', icon: 'now-ui-icons business_chart-pie-36', path: '/charts'}"
        ></sidebar-item>
        <sidebar-item :link="{name: '用戶管理', icon: 'now-ui-icons education_atom'}">
          <sidebar-item :link="{name: 'SI管理', path: '/components/buttons'}"></sidebar-item>
        </sidebar-item>
      </template>-->
      <!-- <template slot-scope="props" slot="links">
        <user-menu></user-menu>
        <sidebar-item :link="{name: 'Dashboard', icon: 'now-ui-icons design_app', path: '/dashboard'}">
        </sidebar-item>
        <sidebar-item :link="{name: 'Pages', icon: 'now-ui-icons design_image'}">
          <sidebar-item :link="{name: 'Pricing', path: '/pricing'}"></sidebar-item>
          <sidebar-item :link="{name: 'Timeline', path: '/pages/timeline'}"></sidebar-item>
          <sidebar-item :link="{name: 'Login', path: '/login'}"></sidebar-item>
          <sidebar-item :link="{name: 'Register', path: '/register'}"></sidebar-item>
          <sidebar-item :link="{name: 'Lock Screen', path: '/lock'}"></sidebar-item>
          <sidebar-item :link="{name: 'User Profile', path: '/pages/user'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Components', icon: 'now-ui-icons education_atom'}">
          <sidebar-item :link="{name: 'Buttons', path: '/components/buttons'}"></sidebar-item>
          <sidebar-item :link="{name: 'Grid System', path: '/components/grid-system'}"></sidebar-item>
          <sidebar-item :link="{name: 'Panels', path: '/components/panels'}"></sidebar-item>
          <sidebar-item :link="{name: 'Sweet Alert', path: '/components/sweet-alert'}"></sidebar-item>
          <sidebar-item :link="{name: 'Notifications', path: '/components/notifications'}"></sidebar-item>
          <sidebar-item :link="{name: 'Icons', path: '/components/icons'}"></sidebar-item>
          <sidebar-item :link="{name: 'Typography', path: '/components/typography'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Forms', icon: 'now-ui-icons files_single-copy-04'}">
          <sidebar-item :link="{name: 'Regular Forms', path: '/forms/regular'}"></sidebar-item>
          <sidebar-item :link="{name: 'Extended Forms', path: '/forms/extended'}"></sidebar-item>
          <sidebar-item :link="{name: 'Validation Forms', path: '/forms/validation'}"></sidebar-item>
          <sidebar-item :link="{name: 'Wizard', path: '/forms/wizard'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Tables', icon: 'now-ui-icons design_bullet-list-67'}">
          <sidebar-item :link="{name: 'Regular Tables', path: '/table-list/regular'}"></sidebar-item>
          <sidebar-item :link="{name: 'Extended Tables', path: '/table-list/extended'}"></sidebar-item>
          <sidebar-item :link="{name: 'Paginated Tables', path: '/table-list/paginated'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Maps', icon: 'now-ui-icons location_pin'}">
          <sidebar-item :link="{name: 'Google Maps', path: '/maps/google'}"></sidebar-item>
          <sidebar-item :link="{name: 'Full Screen Maps', path: '/maps/full-screen'}"></sidebar-item>
          <sidebar-item :link="{name: 'Vector Maps', path: '/maps/vector-map'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{name: 'Widgets', icon: 'now-ui-icons objects_diamond', path: '/widgets'}"></sidebar-item>
        <sidebar-item
          :link="{name: 'Charts', icon: 'now-ui-icons business_chart-pie-36', path: '/charts'}"></sidebar-item>
        <sidebar-item
          :link="{name: 'Calendar', icon: 'now-ui-icons media-1_album', path: '/calendar'}"></sidebar-item>

      </template>-->
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <router-view name="header"></router-view>

      <div :class="{content: !$route.meta.hideContent}" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";

export default {
  data() {
    return {
      menu: []
    };
  },
  computed: {
    userType: function() {
      return this.$store.getters.userType;
    }
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    UserMenu,
    SlideYDownTransition,
    ZoomCenterTransition
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  mounted() {
    // 根據登入類型顯示sidebar
    console.log("test user type " + this.userType);
    switch (this.userType) {
      case "gaa":
        this.menu = [
          {
            name: "營業概況",
            icon: "now-ui-icons business_chart-pie-36",
            path: "/summary",
            children: [
              {
                name: "總覽",
                icon: "el-icon-data-analysis",
                path: "/retail/summary/stat"
              },
              {
                name: "訂單列表",
                icon: "now-ui-icons files_paper",
                path: "/retail/summary/orders"
              },
              {
                name: "店家報表",
                icon: "el-icon-data-line",
                path: "/retail/summary/shop-stat"
              }
            ]
          },
          {
            name: "零售管理",
            icon: "now-ui-icons shopping_shop",
            path: "",
            children: [
              {
                name: "商店管理",
                icon: "el-icon-suitcase",
                path: "/retail/gaa/business"
              },
              {
                name: "商品管理",
                icon: "el-icon-reading",
                path: "/retail/menu-management"
              },
              {
                name: "銷售查詢",
                icon: "el-icon-shopping-cart-full",
                path: "/retail/sales/query"
              },
              {
                name: "封鎖名單",
                icon: "el-icon-remove-outline",
                path: "/retail/sales/banned-list"
              },
              {
                name: "印表機管理",
                icon: "el-icon-printer",
                path: "/retail/printers/list"
              }
            ]
          },
          {
            "name": "入口管理",
            icon: "el-icon-menu shopping_shop",
            path: "",
            children: [
              {
                name: "入口列表",
                icon: "el-icon-menu",
                path: "/retail/portals"
              }
            ]
          },
          {
            name: "用戶管理",
            icon: "now-ui-icons users_single-02",
            path: "/",
            children: [
              {
                name: "GAA 管理員",
                path: "/retail/gaa-users"
              },
              {
                name: "SI 帳戶管理",
                path: "/retail/si-accounts"
              },
              {
                name: "EAA 帳戶管理",
                path: "/retail/eaa-accounts"
              }
              // {
              //   name: "User 帳戶管理",
              //   path: "/users"
              // }
            ]
          },
          {
            name: "登入管理",
            icon: "now-ui-icons users_single-02",
            path: "/",
            children: [
              {
                name: "登入記錄",
                path: "/retail/gaa-login-record"
              }
            ]
          }
        ];
        break;
      case "si":
        this.menu = [
          {
            name: "營業概況",
            icon: "now-ui-icons business_chart-pie-36",
            path: "/summary",
            children: [
              {
                name: "總覽",
                icon: "el-icon-data-analysis",
                path: "/retail/summary/stat"
              },
              {
                name: "訂單列表",
                icon: "now-ui-icons files_paper",
                path: "/retail/summary/orders"
              },
              {
                name: "店家報表",
                icon: "el-icon-data-line",
                path: "/retail/summary/shop-stat"
              }
            ]
          },
          {
            name: "零售管理",
            icon: "now-ui-icons shopping_shop",
            path: "",
            children: [
              {
                name: "商店管理",
                icon: "el-icon-suitcase",
                path: "/retail/si/business"
              },
              {
                name: "菜單管理",
                icon: "el-icon-reading",
                path: "/retail/menu-management"
              },
              {
                name: "銷售查詢",
                icon: "el-icon-shopping-cart-full",
                path: "/retail/sales/query"
              }
            ]
          },
          {
            name: "行銷活動",
            icon: "el-icon-present",
            path: "",
            children: [
              {
                name: "贈送優惠券",
                icon: "el-icon-discount",
                path: "/retail/send-coupons"
              }
            ]
          },
          {
            name: "用戶管理",
            icon: "now-ui-icons users_single-02",
            path: "/",
            children: [
              {
                name: "管理員列表",
                path: "/retail/si-users"
              },
              {
                name: "店家帳戶管理",
                path: "/retail/eaa-accounts"
              }
              // {
              //   name: "User 帳戶管理",
              //   path: "/users"
              // }
            ]
          },
          {
            name: "登入管理",
            icon: "now-ui-icons users_single-02",
            path: "/",
            children: [
              {
                name: "登入記錄",
                path: "/retail/si-login-record"
              }
            ]
          }
        ];
        break;
      case "eaa":
        this.menu = [
          {
            name: "營業概況",
            icon: "now-ui-icons business_chart-pie-36",
            path: "/summary",
            children: [
              {
                name: "總覽",
                icon: "el-icon-data-analysis",
                path: "/retail/summary/stat"
              },
              {
                name: "訂單列表",
                icon: "now-ui-icons files_paper",
                path: "/retail/summary/orders"
              },
              {
                name: "店家報表",
                icon: "el-icon-data-line",
                path: "/retail/summary/shop-stat"
              }
            ]
          },
          {
            name: "零售管理",
            icon: "now-ui-icons shopping_shop",
            path: "",
            children: [
              {
                name: "商店管理",
                icon: "el-icon-suitcase",
                path: "/retail/eaa/business/shop-management"
              },
              {
                name: "菜單管理",
                icon: "el-icon-reading",
                path: "/retail/menu-management"
              },
              {
                name: "銷售查詢",
                icon: "el-icon-shopping-cart-full",
                path: "/retail/sales/query"
              },
              {
                name: "封鎖名單",
                icon: "el-icon-remove-outline",
                path: "/retail/sales/banned-list"
              }
            ]
          },
          {
            name: "用戶管理",
            icon: "now-ui-icons business_chart-pie-36",
            path: "/",
            children: [
              {
                name: "帳戶管理",
                path: "/retail/eaa-account"
              }
            ]
          },
          {
            name: "行銷活動管理",
            icon: "now-ui-icons business_chart-pie-36",
            path: "/",
            children: [
              {
                name: "行銷活動總覽",
                icon: "el-icon-shopping-cart-full",
                path: "/retail/eaa/business/promotions"
              },
              // {
              //   name: "行銷活動設定",
              //   icon: "el-icon-shopping-cart-full",
              //   path: "/eaa/business/promotions"
              // },
              // {
              //   name: "行銷活動報表",
              //   icon: "el-icon-shopping-cart-full",
              //   path: "/eaa/business/promotions"
              // }
            ]
          },
          {
            name: "登入管理",
            icon: "now-ui-icons users_single-02",
            path: "/",
            children: [
              {
                name: "登入記錄",
                path: "/retail/eaa-login-record"
              }
            ]
          }
        ];
        break;
      case "line":
        this.menu = [
          {
            name: "營業概況",
            icon: "now-ui-icons business_chart-pie-36",
            path: "/summary",
            children: [
              {
                name: "圖表",
                path: "/summary/stat"
              },
              {
                name: "訂單列表",
                path: "/summary/orders"
              }
            ]
          },
          {
            name: "店家管理",
            icon: "now-ui-icons shopping_shop",
            path: "",
            children: [
              {
                name: "菜單管理",
                path: "/menu-management"
              }
            ]
          }
        ];
        break;
      default:
    }

    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");

    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}

// Scroll-bar customization
/* width */
::-webkit-scrollbar {
  width: 6px;
}
/* Track */
::-webkit-scrollbar-track {
  // background: #f1f1f1; 
  background: transparent;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 3px;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
</style>
